var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "关于“购物赠VIP会员”活动的规则说明",
      "visible": _vm.dialogVisible,
      "width": "600px",
      "close-on-click-modal": ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popup-body"
  }, [_c('ol', {
    staticClass: "rules-list"
  }, [_c('li', [_vm._v(" 欢迎参与“购物赠VIP会员”活动。请您在参与前仔细阅读以下规则，以确保您充分理解活动的权利与义务。 ")]), _c('li', [_c('span', [_vm._v("第一条 会员赠送规则")])]), _c('li', [_vm._v(" 1.1 赠送标准："), _c('span', [_vm._v("1元=1天VIP")]), _vm._v("。即订单实付金额每满1元，赠送1天VIP会员服务。 ")]), _c('li', [_vm._v(" 1.2 会员权益："), _c('span', [_vm._v("赠送的VIP会员，权益与直接购买的完全一致")]), _vm._v("。 ")]), _c('li', [_vm._v(" 1.2 赠送上限：单个用户通过本活动获得的VIP会员总时长（含已生效及本次即将赠送的时长）存在上限。该上限为"), _c('span', [_vm._v("730天（2年）")]), _vm._v("。 ")]), _c('li', [_vm._v(" 1.3上限计算：系统将自动计算，若您当前生效中的VIP会员剩余天数已达到或超过730天，则本次订单将不再赠送会员天数。 ")]), _c('li', [_vm._v(" 1.4 在本软件官方商城下单购买任意商品，即可自动参与本活动，享受相应权益。 ")]), _c('li', [_c('span', [_vm._v(" 第二条 会员升级")])]), _c('li', [_vm._v(" 2.1 本活动赠送的VIP会员，支持升级至更高级别的会员（如高级会员、团队版会员）。 ")]), _c('li', [_vm._v(" 2.2 您可在会员中心或升级界面，按届时公示的差价支付相应费用，即可完成升级。 ")]), _c('li', [_c('span', [_vm._v(" 第三条 售后与权益收回 ")])]), _c('li', [_vm._v(" 3.1 本活动所涉商品均享受驰腾官方标准的售后服务政策。 ")]), _c('li', [_vm._v(" 3.2 若订单因退款、取消等原因发生售后退款，"), _c('span', [_vm._v("该订单所赠送的VIP会员天数将同步被收回")]), _vm._v("。如收回导致您账户的VIP会员身份失效，相关会员权益将一并终止。 ")]), _c('li', [_c('span', [_vm._v("第四条 其他说明")])]), _c('li', [_vm._v(" 4.1 本活动赠送的会员权益为一次性发放，仅限本账户使用，不得转让或兑换现金。 ")]), _c('li', [_vm._v(" 4.2 我们有权在法律允许的范围内对活动规则进行说明或调整，如有变动将及时公布。 ")]), _c('li', [_vm._v(" 感谢您的参与与支持！ ")])])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };